const pt = {
  slogan: `
    Empoderando as mulheres para trabalhar e prosperar no mundo da tecnologia.
  `,
  'follow-us': 'Acompanhe a gente nas redes sociais',
  'learn-more': 'Saiba mais',
  contact: 'Entre em contato',
  blog: 'Hub de conteúdos',
  privacy: 'Política de privacidade',
  terms: 'Termos e Condições',
  'get-involved': 'Faça parte',
  apply: 'Inscreva-se no bootcamp',
  hire: 'Contrate talentos',
  'work-with-us': 'Trabalhe conosco',
  copyright: 'Todos os direitos reservados.',
};

export default pt;
